import { Genders } from "@/types/gender";

export const MALE_DOMAIN = "zing-gym.coach";
export const FEMALE_DOMAIN = "zingcoach.fit";

export const DOMAIN_BY_GENDER = {
    [Genders.Female]: FEMALE_DOMAIN,
    [Genders.Male]: MALE_DOMAIN,
};
